import React from "react";
import styled, { keyframes, css } from "styled-components";

type SpinnerType = "small" | "medium";
interface SpinnerProps {
  type?: SpinnerType;
}

const Spinner = ({ type = "small" }: SpinnerProps) => <Loader type={type} />;

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const Loader = styled.div<{ type: SpinnerType }>`
  &,
  &:after {
    border-radius: 50%;

    ${(props) => {
      if (props.type === "medium")
        return css`
          width: 30px;
          height: 30px;
        `;
      else if (props.type === "small")
        return css`
          width: 15px;
          height: 15px;
        `;
    }}
  }

  & {
    font-size: 3px;
    position: relative;
    border-top: 3px solid rgba(0, 0, 0, 0.2);
    border-right: 3px solid rgba(0, 0, 0, 0.2);
    border-bottom: 3px solid rgba(0, 0, 0, 0.2);
    border-left: 3px solid #32b0ea;
    transform: translateZ(0);
    animation: ${rotate} 0.8s infinite linear;
  }
`;

export default Spinner;
